import { defineComponent as _defineComponent } from 'vue';
import { PromptEnum, useChatgptTranslateLazyQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'Translate',
  props: {
    value: {
      type: String,
      required: true
    },
    prompt: {
      type: String,
      default: PromptEnum.KpiTranslationPrompt
    }
  },
  setup: function setup(__props) {
    var showTranslationPopover = ref(false);
    var _useChatgptTranslateL = useChatgptTranslateLazyQuery({
        input: {}
      }),
      result = _useChatgptTranslateL.result,
      loading = _useChatgptTranslateL.loading,
      translate = _useChatgptTranslateL.load,
      onResult = _useChatgptTranslateL.onResult;
    onResult(function () {
      // when translation API returns, show the popover
      showTranslationPopover.value = true;
    });
    var translatedResult = computed(function () {
      var _result$value, _result$value$chatgpt, _result$value$chatgpt2;
      return (_result$value = result.value) === null || _result$value === void 0 ? void 0 : (_result$value$chatgpt = _result$value.chatgptTranslate) === null || _result$value$chatgpt === void 0 ? void 0 : (_result$value$chatgpt2 = _result$value$chatgpt[0]) === null || _result$value$chatgpt2 === void 0 ? void 0 : _result$value$chatgpt2.translatedText;
    });
    return {
      __sfc: true,
      showTranslationPopover: showTranslationPopover,
      result: result,
      loading: loading,
      translate: translate,
      onResult: onResult,
      translatedResult: translatedResult
    };
  }
});